// Map route prefixes to feature names for auto-popup tour
// The hook will match by prefix so sub-routes also trigger
export const TOUR_FEATURE_MAP = {
  '/home': 'Home',
  '/job-match-score': 'Job Match Score',
  '/insights': 'Insights',
  '/myjobs': 'My Jobs',
  '/wallet': 'My Wallet',
  '/saved': 'Saved',
  '/invite': 'Invite a Friend',
  '/subscriptions': 'Payhub',
  '/my-subscriptions': 'My Subscription',
  '/profile': 'Profile',
  '/settings': 'Settings',
  '/league': 'Home',
};

export const VISITED_PAGES_KEY = 'workbrook_visited_pages';
